import { SHIFT_UP_MOBILE } from '../items/Item';
import Furniture from './Furniture';

export default class Firefly extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.controller; // reference to controller set in FirefliesCOntroller

    this.pair = null; // other firefly paired with that one
    this.pairTime = 0; // time left the paired fireflies flight together
    this.noPairTime = 0; // time when pair is not possible -> buffer time when firelies end pair so they could get distance
    this.drag = false;
    this.active = false;
    this.visible = false;

    this.setAnim('fly');
  }

  canBePaired() {
    return (
      this.active &&
      !this.pair &&
      !this.drag &&
      !this.isExiting &&
      !this.isEntering &&
      this.noPairTime <= 0
    );
  }

  setPair(pair, isGuide) {
    this.pair = pair;
    this.isGuide = isGuide;
    this.pairTime = 5;
    this.pairInd = 0;

    this.onPlaceInPosition();

    this.setAnim('flash');
  }

  breakPair() {
    if (this.pair) {
      this.setAnim('fly');
      this.pair.setAnim('fly');

      this.pair.noPairTime = 4;
      this.noPairTime = 4;
      this.pair.pair = null;
      this.pair = null;

      this.controller.onBreakPair();
    }
  }

  setLight() {}

  enterLocation() {
    this.isExiting = false;
    this.isEntering = true;
    this.destY = Phaser.Math.between(100, 600);
    if (!this.active) {
      // is inactive then set new start position out of the screen
      this.x = Phaser.Math.between(300, this.location.width - 300); // set first point
      this.y = this.destY < 360 ? -30 : 750;
    }
    this.active = true;
    this.visible = true;

    this.onPlaceInPosition();
  }

  exitLocation() {
    this.breakPair();

    this.isExiting = true;
    this.isEntering = false;
    this.destY = this.y > 360 ? 750 : -50;
  }

  onPlaceInPosition() {
    this.navPoints = { x: [], y: [] };
    this.dir = Math.random() < 0.5 ? -1 : 1; // set flight direction
    if (this.pair && !this.isGuide) {
      this.dir = -this.pair.dir;
    }

    // get first point
    const pt = this.getNextPoint(this.x, this.y, false, true);
    this.navPoints.x.push(pt.x);
    this.navPoints.y.push(pt.y);

    // add current position to nav points (2nd point)
    this.navPoints.x.push(this.x);
    this.navPoints.y.push(this.y);

    // change direction
    this.dir *= -1;

    // add 2 more points
    for (let i = 0; i < 2; i++) {
      const x = this.navPoints.x[this.navPoints.x.length - 1];
      const y = this.navPoints.y[this.navPoints.y.length - 1];
      const pt = this.getNextPoint(x, y, true, true);
      this.navPoints.x.push(pt.x);
      this.navPoints.y.push(pt.y);
    }
    // set position on the 2nd point
    this.x = this.navPoints.x[1];
    this.y = this.navPoints.y[1];

    //
    this.generatePath(this.navPoints.x[1], this.navPoints.y[1]);
    this.time = 0.333;
  }

  /* eslint-disable max-statements */
  getNextPoint(x, y, canChangeDir = true, init = false) {
    // change direction
    if (
      !this.isEntering &&
      !this.isExiting &&
      canChangeDir &&
      (!this.pair || this.isGuide) &&
      Math.random() < 0.2
    ) {
      this.dir *= -1;
    }

    // for paired fireflies - the follower gets guide direction and position
    if (this.pair && !this.isGuide) {
      this.dir = this.pair.dir;
      const ind = init ? this.navPoints.x.length : 3;
      const x1 = this.pair.navPoints.x[ind] + Phaser.Math.between(10, 20) * this.dir;
      const y1 =
        this.pair.navPoints.y[ind] +
        Phaser.Math.between(10, 30) * (this.pairInd % 2 === 0 ? 1 : -1);
      this.pairInd++;
      return { x: x1, y: y1 };
    }

    // set next x point
    let dx = this.dir * Phaser.Math.between(100, 200);
    if (this.isEntering || this.isExiting) {
      dx = this.dir * Phaser.Math.between(40, 60);
    } else if (this.pair) {
      dx = this.dir * Phaser.Math.between(80, 100);
    }
    let x1 = x + dx;
    if (x1 < -50 || x1 > this.location.width + 50) {
      this.dir *= -1;
      dx *= -1;
      x1 = x + dx;
    }

    // set y point
    let y1;
    if (this.isEntering || this.isExiting) {
      const dy = y < this.destY ? 100 : -100;
      y1 = y + dy;
    } else {
      let dy = Phaser.Math.between(-50, 50);
      if (this.pair) {
        dy = Phaser.Math.between(30, 70) * (this.pairInd % 2 === 0 ? -1 : 1);
        this.pairInd++;
      }
      y1 = y + dy;
      if (y1 < 20 || y1 > 700) {
        dy *= -1;
        y1 = y + dy;
      }
    }
    return { x: x1, y: y1 };
  }
  /* eslint-enable */

  generatePath() {
    // generate path
    this.path = [];
    for (let i = 0; i <= 300; i++) {
      const x0 = Phaser.Math.catmullRomInterpolation(this.navPoints.x, i / 300);
      const y0 = Phaser.Math.catmullRomInterpolation(this.navPoints.y, i / 300);
      this.path.push({ x: x0, y: y0 });
    }
  }

  generateNextPath() {
    // remove first item
    this.navPoints.x.shift();
    this.navPoints.y.shift();
    const x = this.navPoints.x[this.navPoints.x.length - 1];
    const y = this.navPoints.y[this.navPoints.y.length - 1];
    const pt = this.getNextPoint(x, y);
    this.navPoints.x.push(pt.x);
    this.navPoints.y.push(pt.y);
    this.generatePath(this.navPoints.x[1], this.navPoints.y[1]);
    this.time = 0.333;
  }

  handleInputDown(target, pointer) {
    target;
    if (!this.isExiting) {
      this.pointer = pointer;
      this.drag = true;
      this.isEntering = false;
      this.breakPair();
    }
  }

  handleInputUp() {
    this.drag = false;
    this.noPairTime = 0;
    this.onPlaceInPosition();
  }

  /* eslint-disable max-statements */
  step(dt) {
    if (!this.active) {
      return;
    }

    // dt = 0.1;

    super.step(dt);

    if (this.drag && this.pointer) {
      // is dragged
      const dy = this.game.deviceMetric.platform.type === 'desktop' ? 0 : SHIFT_UP_MOBILE;
      this.x = -this.location.x + this.pointer.x;
      this.y = this.pointer.y + dy;
    } else {
      // fly
      this.time += dt * (this.isExiting ? 0.6 : this.pair ? 0.6 : 0.2);
      if (this.time <= 0.666) {
        const ind = Math.round(this.time * 300);
        const pt = this.path[ind];
        const dx = pt.x - this.x;
        if (dx !== 0) {
          this.rootBone.scaleX = dx > 0 ? -1 : 1;
        }
        this.x = pt.x;
        this.y = pt.y;
      } else {
        this.generateNextPath();
      }

      //
      if (this.pair) {
        this.pairTime -= dt;

        if (this.pairTime <= 0) {
          this.breakPair();
        }
      } else if (this.noPairTime > 0) {
        this.noPairTime -= dt;
      } else {
        this.controller.tryToPair(this);
      }

      //
      if (this.isEntering) {
        if (
          (this.destY < 360 && this.y >= this.destY - 5) ||
          (this.destY >= 360 && this.y <= this.destY + 5)
        ) {
          this.isEntering = false;
        }
      } else if (this.isExiting) {
        if (
          (this.destY < 0 && this.y <= this.destY + 5) ||
          (this.destY > 0 && this.y >= this.destY - 5)
        ) {
          this.active = false;
          this.visible = false;
        }
      }
    }
  }
  /* eslint-enable */

  removeMe() {
    this.active = false;
    this.visible = false;
  }

  //
  serialize() {
    return null;
  }
}
